import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {ProgressBar} from '../../../../../../../components/ProgressBar/ProgressBar';
import {LanguageContext} from '../../../../../../../contexts/LanguageContext/LanguageContext';
import {orangeColors} from '../../../../../../../layouts/theme/designSystem';
import {JobMatchInformation} from '../../../../../../../types/shared-recruiting-types';

interface Props {
  jobMatchData?: JobMatchInformation;
}

export const JobMatchSection = ({jobMatchData}: Props) => {
  const {t} = useTranslation();
  const lang = useContext(LanguageContext);

  const displayText = jobMatchData?.matchText[lang];
  const score = jobMatchData?.score ?? 0;

  return (
    <Box
      sx={{
        mt: 5,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        backgroundColor: orangeColors[5],
        padding: {xs: 1.5, md: 2.5},
        borderRadius: 1.25,
      }}
    >
      <Typography variant='h2'>{displayText}</Typography>
      <ProgressBar
        percent={score}
        typography={
          <Typography variant='body1' color='white'>
            {t('matchInformation.jobMatch.label')} {score}%
          </Typography>
        }
      />
    </Box>
  );
};
